import { Box, Container, SimpleGrid, Heading, Text, VStack, Link, HStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { NavLink } from '../common/NavLink';

const Footer = () => {
  return (
    <Box 
      bg="linear-gradient(180deg, #0f3d28 0%, #1a5e3f 50%, #0f3d28 100%)" 
      color="white" 
      py={12} 
      borderTop="1px solid" 
      borderColor="rgba(255, 255, 255, 0.1)"
      position="relative"
      overflow="hidden"
      _before={{
        content: '""',
        position: 'absolute',
        bottom: '-30%',
        right: '-20%',
        width: '400px',
        height: '400px',
        bg: 'radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none',
      }}
    >      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 3, lg: 4 }} spacing={8} mb={8}>
          {/* Brand Section */}
          <VStack align="start" spacing={3}>
            <Box mb={2}>
              <HStack spacing={1}>
                <Box fontSize="20px">🌾</Box>
                <Heading size="md" fontSize="20px" color="white">
                  MarketLink
                </Heading>
              </HStack>
              <Text fontSize="11px" color="neutral.400" mt={0}>
                Agriculture made easy
              </Text>
            </Box>
          </VStack>

          {/* Product Links */}
          <VStack align="start" spacing={3}>
            <Heading size="sm" fontSize="13px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.5px">
              Product
            </Heading>
            <VStack align="start" spacing={2}>
              <Link
                as={RouterLink}
                to="/marketplace"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
                Marketplace
              </Link>
              <Link
                as={RouterLink}
                to="/about"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
                Features
              </Link>
              <Link
                as={RouterLink}
                to="/chatbot"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
                AI Support
              </Link>
            </VStack>
          </VStack>

          {/* Resources Links */}
          <VStack align="start" spacing={3}>
            <Heading size="sm" fontSize="13px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.5px">
              Resources
            </Heading>
            <VStack align="start" spacing={2}>
              <Link
                href="/"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
                Documentation
              </Link>
              <Link
                href="/"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
                Guide
              </Link>
              <Link
                href="/"
                fontSize="13px"
                color="neutral.400"
                transition="color 0.2s"
                _hover={{ color: 'primary.300' }}
              >
 FAQ
              </Link>
            </VStack>
          </VStack>

          {/* Contact Section */}
          <VStack align="start" spacing={3}>
            <Heading size="sm" fontSize="13px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.5px">
              Contact
            </Heading>
            <VStack align="start" spacing={2} fontSize="13px">
              <Text color="neutral.400">
                <Text as="span" fontWeight="600" color="neutral.300">Email:</Text>{' '}
                support@marketlink.co.zw
              </Text>
              <Text color="neutral.400">
                <Text as="span" fontWeight="600" color="neutral.300">USSD:</Text>{' '}
                *384*27858#
              </Text>
              <Text color="neutral.400">
                <Text as="span" fontWeight="600" color="neutral.300">Phone:</Text>{' '}
                +263 783 006 221
              </Text>
              <HStack align="flex-start" color="neutral.400" spacing={1}>
                <Text fontWeight="600" color="neutral.300">Whatsapp:</Text>
                <VStack spacing={0} align="flex-start">
                  <Text>+263 783 006 221</Text>
                  <Text>+263 775 116 054</Text>
                </VStack>
              </HStack>
            </VStack>
          </VStack>
        </SimpleGrid>

        {/* Divider */}
        <Box h="1px" bg="neutral.800" w="full" mb={6} />

        {/* Footer Bottom */}
        <VStack spacing={4}>
          <Text textAlign="center" fontSize="12px" color="neutral.500">
            © {new Date().getFullYear()} MarketLink Agro-Marketplace. All rights reserved.
          </Text>
          <HStack spacing={6} justify="center" fontSize="12px">
            <Link as={RouterLink} to="/privacy-policy" color="neutral.500" transition="color 0.2s" _hover={{ color: 'primary.300' }}>
              Privacy Policy
            </Link>
            <Box h="1px" w="4px" bg="neutral.700" />
            <Link as={RouterLink} to="/terms-of-service" color="neutral.500" transition="color 0.2s" _hover={{ color: 'primary.300' }}>
              Terms of Service
            </Link>
            <Box h="1px" w="4px" bg="neutral.700" />
            <Link as={RouterLink} to="/contact-us" color="neutral.500" transition="color 0.2s" _hover={{ color: 'primary.300' }}>
              Contact Us
            </Link>
          </HStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;